import { generateRealTimeToken, removeRealTimeToken } from "./redux/slices/auth";
import OneSignal from "react-onesignal";
import { toast } from "react-toastify";

export const initializeOneSignal = async () => {
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      const swUrl = registration?.active?.scriptURL || "";
      if (swUrl.includes("firebase-messaging-sw.js")) {
        await registration.unregister();
        deleteFirebaseDatabases();
      }
    }

    const payload = {
      web_device_token: OneSignal?.User?.PushSubscription?.id
    }
    generateRealTimeToken(payload,
      (response) => { },
      (error) => {
        toast.error(error?.message);
      }
    );

  } catch (error) {
    console.error("OneSignal init error:", error);
  }
};


export const cleanupOneSignal = async () => {
  try {
      const payload = { web_device_token: 'EMPTY' }
      removeRealTimeToken(payload,
        (response) => { },
        (error) => {
          toast.error(error?.message);
        }
      );

    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      const swUrl = registration.active?.scriptURL || "";
      if (swUrl.includes("firebase-messaging-sw.js")) {
        await registration.unregister();
      }
    }

    deleteFirebaseDatabases();

    localStorage.removeItem("os_pageViews");
    sessionStorage.clear();

  } catch (err) {
    console.error("OneSignal cleanup error:", err);
  }
};


const deleteFirebaseDatabases = async () => {
  const dbsToDelete = [
    "firebase-heartbeat-database",
    "firebase-installations-database",
    "firebase-messaging-database",
    "firebaseLocalStorageDb",
  ];

  dbsToDelete?.forEach((dbName) => {
    const deleteRequest = indexedDB?.deleteDatabase(dbName);
    deleteRequest.onsuccess = () => { };
    deleteRequest.onerror = () => { };
    deleteRequest.onblocked = () => { };
  });
};

